import { ReactNode } from "react";
import { serializedAmpEvent } from "./amp-form-utils";

export interface AmpFormProps {
  id: string;
  children: ReactNode;
  onSubmit?: string;
  onSubmitSuccess?: string;
  onSubmitError?: string;
  actionXhr: string;
  submitting?: ReactNode;
  submitSuccess?: ReactNode;
  submitError?: ReactNode;
}

export function AmpForm(props: AmpFormProps) {
  const onSubmit = serializedAmpEvent("submit", props.onSubmit);
  const onSubmitSuccess = serializedAmpEvent(
    "submit-success",
    props.onSubmitSuccess,
  );
  const onSubmitError = serializedAmpEvent("submit-error", props.onSubmitError);

  const on = [onSubmit, onSubmitSuccess, onSubmitError]
    .filter(Boolean)
    .join(";");

  return (
    <form action-xhr={props.actionXhr} id={props.id} method="post" on={on}>
      {props.children}

      {props.submitting && <div submitting="">{props.submitting}</div>}

      {props.submitSuccess && (
        <div submit-success="">{props.submitSuccess}</div>
      )}

      {props.submitError && <div submit-error="">{props.submitError}</div>}
    </form>
  );
}
